export const GET_CARS = 'GET_CARS'
export const GET_CARS_SUCCESS = 'GET_CARS_SUCCESS'
export const UPDATE_CARS_PAGINATION = 'UPDATE_CARS_PAGINATION'